import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem, _EcmDocument, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { SingPanelEditor } from "../../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    StartProcess: string;
    IDSignPanel: number;
}

export const BPM007 = ({ configProcedure }: Props) => {

    const { instance } = useDataBean(_EcmDocument);
    const [props, setProps] = useState<any>({})

    const [response, setResponse] = useState<Partial<Resp>>({
        StartProcess: "false",
        IDSignPanel: null
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])


    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Obs)
        }

        if (response.StartProcess === "true") {
            instance.fireSigningDocumentFlow(props.IDDocument, props.Mnemonic, props.DocumentDate, response.IDSignPanel, _single.getAccountID()).then((resp: any) => {
                if (configProcedure?._pushProps) {
                    configProcedure?._pushProps({
                        IDSignPanel: response.IDSignPanel
                    })
                }

                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(response)
                }
            }).catch(
                err => { toast.error(err) }
            );
        } else {
            if (configProcedure?._pushProps) {
                configProcedure?._pushProps({
                    IDSignPanel: response.IDSignPanel
                })
            }

            if (configProcedure?._exportMap) {
                configProcedure?._exportMap(response)
            }
        }
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label>Iniciar Flujo de Firmas:</label>
                <select className="form-select" disabled={!props.IDDocument} value={response.StartProcess} onChange={(e) => { setResponse({ ...response, "StartProcess": e.target.value }) }} >
                    <option value={"false"} >No</option>
                    <option value={"true"} >Si</option>
                </select>
            </div>
            {response.StartProcess === "true" &&
                <div className="col-md-6">
                    <SingPanelEditor idSelector={response.IDSignPanel} onChange={(e) => { setResponse({ ...response, "IDSignPanel": e }) }} />
                </div>
            }
            <div className="col-md-12">
                <label>Justificación</label>
                <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
            </div>
            <div className="col-md-12 mt-2">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={"Continuar"} />
            </div>
        </div>
    );
}